exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-picture {\n  height: 100px;\n  width: 100px; }\n\n.profile-picture-container {\n  margin: auto; }\n\n.puesto-info {\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/contacto-detail/contacto-detail.component.scss
// module id = ../../../../../src/app/components/cuentas/contacto-detail/contacto-detail.component.scss
// module chunks = 0